import React from "react";

export default function mouthSerious(): React.ReactElement {
  return (
    <svg
      style={{
        width: "45%",
        height: "12%",
        position: "absolute",
        top: "28%",
        right: "25%",
      }}
      width="56"
      height="40"
      viewBox="0 0 56 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Straight serious line */}
      <path
        d="M8 20L48 20"
        stroke="black"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
}
